import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import Entry from "./Entry";
import { store } from "./store/store";
import { defined } from "@entrilia/shared/utilities/typeHelper";

createRoot(defined(document.getElementById("root"))).render(
  <React.StrictMode>
    <BrowserRouter>
      <Provider store={store}>
        <Entry />
      </Provider>
    </BrowserRouter>
  </React.StrictMode>
);
